export default __webpack_public_path__ + "static/media/thiensat.54e165d9.png";